// Tryndamere — Bloodlust: slashes the target for bonus damage and heals himself.
// His 30% crit chance is a champion-def stat handled by ActionResolver.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const tryndamereBloodlust: Ability = {
  id: "tryndamereBloodlust",
  displayName: "Bloodlust",
  description: "Slashes the target for 1.4× AD + 30 physical damage and heals himself for 8% max HP.",
  iconId: "TryndamereQ",

  targetShape({ target }) {
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const dmg = physicalDamage(stats.ad * 1.4 + 33);
    const healAmt = Math.round(effectiveStats(caster).maxHp * 0.08);
    return [
      { target, amount: dmg, type: "physical" },
      { target: caster, amount: 0, type: "none", heal: healAmt },
    ];
  },
};
